export default "__VITE_ASSET__BkV8OQ2e__"